<div class="form-metrics-dashboard">
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Carregando...</span>
    </div>
  </div>

  <ng-container *ngIf="!loading">
    <div *ngIf="!dashboard" class="card card-fit">
      <div class="card-body">
        <p class="text-muted text-center py-4 mb-0">Selecione um formulário para visualizar os indicadores.</p>
      </div>
    </div>

    <ng-container *ngIf="dashboard">
      <div class="dashboard-header mb-2" *ngIf="showHeader">
        <h4 class="mb-50 d-inline-flex align-items-center">
          <span>{{ dashboard.formTitle }}</span>
          <span
            *ngIf="highlightLoading"
            class="spinner-border spinner-border-sm text-primary ml-1"
            role="status"
            aria-live="polite">
            <span class="sr-only">Carregando respondente...</span>
          </span>
        </h4>
        <p class="text-muted mb-0">
          {{ dashboard.filteredSubmissions }} respostas no período
          <span *ngIf="dashboard.totalSubmissions != null">
            (de {{ dashboard.totalSubmissions }} total)
          </span>
        </p>
      </div>

      <div *ngIf="!hasVisibleItems" class="card card-fit">
        <div class="card-body">
          <p class="text-muted text-center py-4 mb-0">
            Nenhum indicador configurado neste formulário. Configure o tipo de gráfico nas perguntas.
          </p>
        </div>
      </div>

      <div *ngIf="hasVisibleItems && allItemsEmpty" class="alert alert-secondary" role="status">
        Sem respostas no período selecionado.
      </div>

      <app-form-metrics-group-section
        *ngFor="let group of sortedGroups; trackBy: trackByGroupId"
        [group]="group"
        [highlightedEmployeeId]="highlightedEmployeeId"
        [categoryClickEnabled]="categoryClickEnabled"
        [highlightAnswers]="highlightAnswers"
        (openComments)="openComments($event)"
        (categoryClick)="onCategoryClick($event)">
      </app-form-metrics-group-section>
    </ng-container>
  </ng-container>
</div>
